import brand from '@helpers/brand';
import { fluidAdjusted } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import { paragraphMedium } from '@helpers/typography';
import { staggerChildren, verticalFadeIn } from '@helpers/variants';
import { SearchResultCardStyles } from '@stories/Components/Cards/SearchResultCard/SearchResultCard.styles';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import { m } from 'framer-motion';
import styled from 'styled-components';
import HeaderStyles from '../Header.styles';
const Container = styled(m.div).attrs((inView) => ({
    initial: 'hidden',
    animate: inView ? 'visible' : 'hidden',
    exit: 'hidden',
})) `
  ${SectionWrapperStyles.Inner} {
    padding: 50px 0 0;

    overflow-y: scroll;
    height: 100%;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  ${HeaderStyles.PopularSearches} {
    position: relative;
  }

  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  ${() => SectionWrapperStyles.Container} {
    width: 100%;
  }
`;
const Background = styled.div `
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-color: ${brand.buff.buff1};

  svg {
    position: absolute;

    &:first-child {
      inset: 0;
      max-width: 500px;
    }

    &:nth-child(2) {
      left: 40px;
      bottom: 0;
      max-width: 500px;
    }

    @media ${until(Device.MobileLarge)} {
      &:nth-child(2) {
        position: absolute;
        left: 20px;
        width: 100%;
        max-width: 90%;
      }
    }

    &:last-child {
      bottom: 0;
      right: 0;
      height: 80%;
    }
  }
`;
const TopBar = styled.div `
  @media ${until(Device.TabletLarge)} {
    display: flex;
    flex-direction: column;
  }

  @media ${from(Device.TabletLarge)} {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  width: 100%;
`;
const ShowingResults = styled.div `
  ${paragraphMedium}
  span {
    font-weight: 900;
  }

  @media ${until(Device.TabletLarge)} {
    text-align: center;
  }
`;
const Tabs = styled.div `
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: ${fluidAdjusted(20, 50, Device.Mobile, Device.ActualDesktop)};

  @media ${until(Device.TabletLarge)} {
    order: -1;
  }
`;
const Tab = styled.div `
  ${paragraphMedium}
  font-weight: 700;
  color: ${brand.secondary.red5};
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: opacity 0.2s ease-in-out, border-bottom-color 0.2s ease-in-out;
  user-select: none;

  opacity: 0.5;
  &:hover {
    opacity: 0.7;
  }

  &[data-active='true'] {
    border-bottom-color: ${brand.secondary.red5};
    opacity: 1;
    &:hover {
      opacity: 1;
    }
  }
`;
const ViewAll = styled.a `
  ${paragraphMedium}
  width: max-content;
  color: ${brand.black};
  display: grid;
  grid-template-columns: max-content 15px;
  gap: 8px;
  align-items: center;
  font-weight: 700;
  max-width: 100%;
  margin-left: auto;

  svg {
    max-height: 15px;
  }
`;
const ResultsListing = styled(m.div).attrs(() => ({
    variants: staggerChildren(0.1),
})) `
  max-width: 740px;
  margin: auto;

  ${SearchResultCardStyles.Container}:last-of-type {
    border-bottom: none;
  }
`;
const Pagination = styled.div `
  margin: 35px 0px;
`;
const ResultsWrapper = styled(m.div).attrs(() => ({
    variants: verticalFadeIn(25),
})) ``;
export const SearchModalStyles = {
    Container,
    Background,
    TopBar,
    ShowingResults,
    Tabs,
    Tab,
    ViewAll,
    ResultsListing,
    Pagination,
    ResultsWrapper,
};
